import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { GridModule } from '@mds/ui';
import { GridOverrides } from '@mds/common';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-epd-info-table',
  templateUrl: './epd-info-table.component.html',
  styleUrls: ['./epd-info-table.component.scss'],
  standalone: true,
  imports: [MatCardModule, GridModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdInfoTableComponent implements OnChanges {
  title: string | null;
  @Input() data;
  overrides: GridOverrides;

  ngOnChanges(): void {
    if (!this.data) return;
    this.title = this.data.title;

    const columns: ColDef[] = this.data.headers.map(({ name, key }) => ({
      headerName: name,
      headerTooltip: name,
      field: key,
      tooltipField: key
    }));
    columns[0].minWidth = 320;

    const rowData = this.data.rows.map((row) => {
      row.stages.forEach(({ code, display_value, value }) => (row[code] = display_value || value));
      return row;
    });

    this.overrides = {
      columnDefs: columns,
      rowData,
      defaultColDef: {
        flex: 1,
        suppressColumnsToolPanel: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        wrapText: true,
        autoHeight: true,
        resizable: true
      },
      sideBar: false,
      groupDefaultExpanded: 1,
      suppressRowClickSelection: true,
      suppressAggFuncInHeader: true,
      pagination: false
    };
  }
}
